import AttivitaTab from '../attivita/AttivitaTab';

interface ClientVisiteTabProps {
  clientId: string;
}

export default function ClientVisiteTab({ clientId }: ClientVisiteTabProps) {
  return <AttivitaTab context={{ kind: 'cliente', id: clientId }} />;
}
